import React from 'react'
import { ALIGNMENT } from './Button'

interface Props {
  color: string
  iconAligned: ALIGNMENT
  icon: React.ReactElement<{ style?: React.CSSProperties }>
}

export const Icon: React.FC<Props> = ({ color, iconAligned, icon }) => {
  let margin = iconAligned === 'left' ? '0 16px 0 0' : '0 0 0 16px'
  margin = iconAligned === 'center' ? '0 0 0 0' : margin
  const height = '16px'
  return React.cloneElement(icon, { style: { height, color, margin, fontSize: height } })
}
